import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import Icon from 'utils/components/icon';
import InfoTooltip from '../../../../../../../../libraries/utils/components/info-tooltip';
import { getTagText } from '../../../header/tag-tooltip';

class Tag extends Component {
  static propTypes = {
    text: PropTypes.string,
    color: PropTypes.string,
    tooltip: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    type: PropTypes.string,
    onClick: PropTypes.func.isRequired,
    sendHoverEventData: PropTypes.func,
    className: PropTypes.string,
    shouldAddClickableIcon: PropTypes.bool,
    isTagActive: PropTypes.bool
  };

  state = {
    cursorOnElement: false
  };

  static defaultProps = {
    onClick: () => {}
  };

  static displayName = 'Tag';

  showTooltip() {
    setTimeout(() => this.showTooltipInfo(), 100);
    this.setState({ cursorOnElement: true });
  }

  showTooltipInfo() {
    const { type } = this.props;
    if (this.state.cursorOnElement) {
      this.refs?.infoTooltip?.show();
    }
  }

  hideIfOutOfTarget() {
    if (!this.state.cursorOnElement) {
      this.refs?.infoTooltip?.hide();
      this.setState({ cursorOnElement: false });
    }
  }

  hideTooltip() {
    setTimeout(() => this.hideIfOutOfTarget(), 500);
    this.setState({ cursorOnElement: false });
  }

  render() {
    const { color, text, type, tooltip, onClick } = this.props;
    const style = { backgroundColor: '#db3737' };

    switch (color) {
      case '':
        style.backgroundColor = '';
        break;
      case 'black':
        style.backgroundColor = '#373e44';
        break;
      case 'grey':
        style.backgroundColor = '#07070733';
        break;
      case 'orange':
        style.backgroundColor = '#f67828';
        break;
      case 'blue':
        style.backgroundColor = '#0352cc';
        break;
      case 'yellow':
        style.backgroundColor = '#f3bb1d';
        break;
      case 'blue':
        style.backgroundColor = '#307fe2';
        break;
    }

    const className = cx('tag disabled', {
      [this.props.className]: this.props.className,
      ['icon']: this.props.shouldAddClickableIcon,
      ['tag-active']: this.props.isTagActive
    });

    return (
      <span
        className={className}
        style={style}
        ref={'infoTooltipAlign'}
        onClick={onClick}
        onMouseEnter={this.showTooltip.bind(this)}
        onMouseLeave={this.hideTooltip.bind(this)}
      >
        {tooltip && (
          <InfoTooltip
            ref={'infoTooltip'}
            alignElement={() => this.refs.infoTooltipAlign}
            direction={'bottom'}
          >
            <span className={'text'}>{tooltip}</span>
          </InfoTooltip>
        )}
        {text || getTagText(type)}
        {this.props.shouldAddClickableIcon && <Icon name="eye" className="tag-icon" />}
      </span>
    );
  }
}

export default Tag;
